module.exports = __webpack_public_path__ + "img/Woveon0.c81ad0bf.svg";